import {FunctionComponent} from "react";
import {Consultant} from "../../../../types";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

interface Props {
  consultant: Consultant;
}

const ConsultantPopupCard: FunctionComponent<Props> = ({consultant}) => {
  const {t} = useTranslation();
  const placeholderImage = '/logo.jpg';

  return (
    <div className="flex items-center gap-3 py-2 border-b border-gray-200 last:border-b-0">
      <img
        src={consultant.profile_image_thumb || consultant.registration?.logo_thumb || placeholderImage}
        alt={consultant.name}
        className="w-10 h-10 rounded-full object-cover flex-shrink-0"
      />
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm text-gray-900 truncate">{consultant.name}</p>
        {consultant.registration?.name && (
          <p className="text-xs text-gray-500 truncate">{consultant.registration.name}</p>
        )}
      </div>
      <Link
        to={`/pages/help/consultant/${consultant.id}`}
        className="bg-blue-500 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1 rounded transition-colors flex-shrink-0"
      >
        {t('consultantFinder.detail')}
      </Link>
    </div>
  );
};

export default ConsultantPopupCard;
